// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import ImageUploadController from "./image_upload_controller"
import TabsController from "./tabs_controller"
import ArtStylePickerController from "./art_style_picker_controller"
import GiftMessageController from "./gift_message_controller"
import GiftModalController from "./gift_modal_controller"


application.register("image-upload", ImageUploadController)
application.register("tabs", TabsController)
application.register("art-style-picker", ArtStylePickerController)
application.register("gift-message", GiftMessageController)
application.register("gift-modal", GiftModalController)

import CharacterDeleteController from "./character_delete_controller"
application.register("character-delete", CharacterDeleteController)
